import gql from "graphql-tag";

export const DELETE_PRODUCT_MUTATION = gql`
  mutation DeleteProduct($productId: ID!) {
    deleteProduct(productId: $productId)
  }
`;
